<template>

    <div 
        id="optimize99-ab-test-editor" 
        class="optimize99-ab-test-editor"
        :class="{
            'optimize99-ab-test-editor-edit-mode': is_edit_text
        }"
        ref="editor"
    >
        <template v-if="is_edit_text">
            <div class="optimize99-ab-test-editor-edit-mode-panel">
                
                <template v-if="this.is_interactivate_plugin">
                    <v-btn
                        color="primary"
                        class="mr-3"
                        @click="cancelEdit"
                    >
                        返回
                    </v-btn>
                </template>
                <template v-else>
                    <v-btn
                        color="primary"
                        class="mr-3"
                        @click="confirmEdit"
                    >
                        確定
                    </v-btn>

                    <v-btn
                        @click="cancelEdit"
                    >
                        取消
                    </v-btn>
                </template> 

            </div>
        </template>


        <template v-if="!is_edit_text">
            <div 
                ref="editor-header"
                class="d-flex justify-end align-center optimize99-ab-test-editor-header"
                :class="{
                    'plugin': editor_type === 'plugin' && plugin_type !== 'animation'
                }"
                @mousedown="moveEditor"
            >
                <!-- {{step_history_index}} -->
                <!-- 上一步 -->
                <v-btn
                    :disabled="step_history_index === -1"
                    class="d-flex align-center"
                    @click="handleHistory('previous')"
                    icon
                >
                    <v-icon
                        icon
                        class="optimize99-ab-test-editor-header-icon"
                        color="#FFF"
                    >
                        mdi-arrow-u-left-top
                    </v-icon>
                </v-btn>

                <!-- 下一步 -->
                <v-btn
                    class="d-flex align-center"
                    icon
                    :disabled="(step_historys.length === 0 || step_history_index === step_historys.length - 1)"
                    @click="handleHistory('next')"
                >
                    <v-icon
                        class="optimize99-ab-test-editor-header-icon"
                        color="#FFF"
                    >
                        mdi-arrow-u-right-top
                    </v-icon>
                </v-btn>

                <!-- 縮小tool bar -->
                <!-- <v-btn
                    class="d-flex align-center"
                    icon
                    @click="closeEditor"
                >
                    <v-icon 
                        class="optimize99-ab-test-editor-header-icon"
                        color="#FFF"
                    >
                        mdi-minus
                    </v-icon>
                </v-btn> -->

            </div>

            <div 
                v-if="!editor_type || plugin_type === 'animation'"
                class="optimize99-ab-test-editor-tool"
                ref="optimize99-ab-test-editor-tool"
            >

                <div 
                    class="pt-4 pb-4"
                >   
                    <v-menu 
                        @input="handleOverlay($event)"
                    >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="#5087e6"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            block
                        >
                        編輯區塊
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item
                            v-for="(item, index) in items"
                            :key="index"
                            link
                            @click="selectedEditMethod(item.action)"
                            :disabled="!selected_element_info || item.inactivate_edit_tags.includes(selected_element_info.nodeName)"
                        >
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                    </v-menu>

                    
                </div>

                <div 
                    class="pt-0 pb-4"
                > 
                    <v-btn
                        color="purple"
                        dark
                        block
                        @click="selectedEditMethod('edit_plugin')"
                    >
                        新增插件
                    </v-btn>
                </div>

                <!-- attribute區塊 -->
                <div>
                    <section v-for="(attribute, key) in selected_element_info.attributes" :key="key">
                        <h2 class="optimize99-ab-test-editor-field-title"
                        >
                            {{attribute_mapper[key].title}}
                        </h2>
                        <v-text-field
                            class="pa-0 ma-0"
                            hide-details
                            :value="attribute"
                            outlined
                            dense
                            @blur="changeAttribute(selected_element_info, key, $event)"
                        >
                        </v-text-field>
                    </section>
                </div>

                <!-- 樣式區塊 -->
                <template v-for="(css_block, block_key) in css_mapper">

                    <div v-if="css_block.visible" :key="block_key">

                        <h2 class="optimize99-ab-test-editor-field-title"
                        >
                            {{css_block.block_title}}
                        </h2>

                        <template
                            v-for="(css, css_name) in css_mapper[block_key]"
                        >
                            <div
                                :key="css_name"
                                class="optimize99-ab-test-editor-field"
                                v-if="hide_css_fields.includes(css_name) === false"
                            >
                                <i v-if="css.icon !== '' " class="material-icons">
                                    {{css.icon}}
                                </i>
                                <v-icon v-else>
                                    {{css.icon_2}}
                                </v-icon>
                                    
                                <v-tooltip
                                    class="pa-0"
                                    nudge-right="20"
                                    left
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        
                                        <v-text-field
                                            v-if="css.item_mapper"
                                            v-bind="attrs"
                                            v-on="on"
                                            :value="selected_element_info.css ? css.item_mapper[selected_element_info.css[css_name]] ? css.item_mapper[selected_element_info.css[css_name]] : selected_element_info.css[css_name] : ''"
                                            outlined
                                            dense
                                            hide-details
                                            class="pa-0 ma-0 optimize99-ab-test-editor-field-input"
                                            @blur="changeStyle(selected_element_info, css_name, $event, null ,true)"
                                        >
                                        </v-text-field>

                                        <v-text-field
                                            v-else
                                            v-bind="attrs"
                                            v-on="on"
                                            :value="selected_element_info.css ? selected_element_info.css[css_name] : ''"
                                            outlined
                                            dense
                                            hide-details
                                            class="pa-0 ma-0 optimize99-ab-test-editor-field-input"
                                            @blur="changeStyle(selected_element_info, css_name, $event, null, true)"
                                        >
                                        </v-text-field>
                                    </template>
                                    <span>
                                        {{css.title}}
                                    </span>
                                </v-tooltip>          
                                <v-menu
                                    @input="handleMenu(css_name, $event)"
                                    :close-on-content-click="!css_name.includes('color')"
                                    left 
                                    bottom
                                    min-width="168px"
                                    max-height="350px"
                                    :ref="`optimize99-ab-test-editor-field-menu-${css_name}`"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon v-if="css_name.includes('color') === false">
                                                mdi-menu-down
                                            </v-icon>

                                            <v-icon v-else>
                                                mdi-dots-horizontal
                                            </v-icon>
                                        </v-btn>
                                    </template>

                                    <!-- 如果是下拉式選單 -->
                                    <v-list v-if="css.items" dense>
                                        <v-list-item
                                            link
                                            v-for="(item, index) in css.items"
                                            :key="index"
                                            :class="{
                                                'item-selected': selected_element_info.css && selected_element_info.css[css_name] === item.value
                                            }"
                                            @click="selectOption($event, item)"
                                        >
                                            <v-list-item-title>{{ item.text }}</v-list-item-title>

                                            <v-list-item-icon 
                                                v-if="selected_element_info.css"
                                            >
                                                <v-icon
                                                    v-if="item.value === selected_element_info.css[css_name]"
                                                >
                                                    mdi-check
                                                </v-icon>
                                            </v-list-item-icon>
                                        </v-list-item>
                                    </v-list>


                                    <v-color-picker 
                                        flat
                                        width="300px"
                                        v-else-if="!css.items && selected_element_info.css"
                                        :value="parseColor(selected_element_info.css[css_name], css_name)"
                                        @input="selectOption($event, $event, css_name)"
                                    >
                                    </v-color-picker>
                                </v-menu>
                            </div>
                        </template>
                    </div>

                </template>
            </div>

            <div 
                v-else-if="editor_type === 'plugin' && editor_type !== 'animation'"
                class="optimize99-ab-test-editor-tool"
                ref="optimize99-ab-test-editor-tool"
            >
                <div 
                    class="pt-4 pb-4"
                >   
                    <v-btn
                        color="error"
                        dark
                        block
                        @click="selectedPluginEditMethod('display')"
                    >
                        移除
                    </v-btn>
                </div>

                <div 
                    class="pb-4"
                >   
                    <v-btn
                        color="primary"
                        dark
                        block
                        @click="interActive"
                    >
                        互動
                    </v-btn>
                </div>

                <template v-for="(css_block, block_key) in plugin_fields[plugin_type]">

                    <div v-if="css_block.visible" :key="block_key">

                        <h2 class="optimize99-ab-test-editor-field-title"
                        >
                            {{css_block.block_title}}
                        </h2>

                        <template
                            v-for="(css, css_name) in plugin_fields[plugin_type][block_key]"
                        >
                            <div
                                :key="css_name"
                                class="optimize99-ab-test-editor-field"
                                v-if="hide_css_fields.includes(css_name) === false"
                            >
                                
                                <span v-if="css.icon && css.icon.includes('mdi') === false " class="material-symbols-outlined">
                                    <template v-if="css.field_display_map !== undefined">
                                        {{getDisaplyValue('icon', css.field_display_map, plugin_param, css)}}
                                    </template>
                                    <template v-else>
                                        {{css.icon}}
                                    </template>
                                </span>
                                <v-icon v-else>
                                    {{css.icon}}
                                </v-icon>
                                    
                                <v-tooltip
                                    class="pa-0"
                                    nudge-right="20"
                                    left
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <!-- {{css_name}} -->
                                        <!-- {{plugin_param[block_key][css.param_type][]}} -->
                                        <v-text-field
                                            @compositionstart="lockInputPluginField(css, true)"
                                            @compositionend="lockInputPluginField(css, false, block_key, css.param_type, css_name, $event, css, css_block)"
                                            @input="inputPluginField(block_key, css.param_type, css_name, $event, css, css_block, true)"
                                            :value="getShowValue(css.display_value, plugin_param[block_key][css.param_type][css_name])"
                                            :readonly="css.readonly"
                                            :disabled="getDisaplyValue('disabled', css.field_display_map, plugin_param, css)"
                                            :placeholder="css.placeholder"
                                            :type="css.type"
                                            v-bind="attrs"
                                            v-on="on"
                                            outlined
                                            dense
                                            hide-details
                                            class="pa-0 ma-0 optimize99-ab-test-editor-field-input"
                                        >
                                        </v-text-field>
                                        
                                    </template>
                                    <span v-if="css.field_display_map === undefined">
                                        {{css.title}}
                                    </span>
                                    <span v-else>
                                        {{ getDisaplyValue('title', css.field_display_map, plugin_param,css)}}
                                    </span>
                                </v-tooltip>
       
                                <v-menu
                                    v-if="css.select_type !== false"
                                    @input="handlePluginMenu(css_name, $event)"
                                    :close-on-content-click="!css_name.includes('color')"
                                    left 
                                    bottom
                                    min-width="168px"
                                    max-height="350px"
                                    :ref="`optimize99-ab-test-editor-field-menu-${css_name}`"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon v-if="css_name.includes('color') === false">
                                                mdi-menu-down
                                            </v-icon>

                                            <v-icon v-else>
                                                mdi-dots-horizontal
                                            </v-icon>
                                        </v-btn>
                                    </template>

                                    <!-- 如果是下拉式選單 -->
                                    <v-list 
                                        v-if="css.select_type === 'select'" 
                                        dense
                                    >
                                        <v-list-item
                                            link
                                            v-for="(item, index) in css.items"
                                            :key="index"
                                            :class="{
                                                'item-selected': selected_element_info.css && selected_element_info.css[css_name] === item.value
                                            }"
                                            @click="selectPluginOption(block_key, css.param_type, css_name, $event, css, css_block, 'item', item)"
                                        >
                                            <v-list-item-title>{{ item.text }}</v-list-item-title>

                                            <v-list-item-icon 
                                                v-if="selected_element_info.css"
                                            >
                                                <v-icon
                                                    v-if="item.value === selected_element_info.css[css_name]"
                                                >
                                                    mdi-check
                                                </v-icon>
                                            </v-list-item-icon>
                                        </v-list-item>
                                    </v-list>


                                    <v-color-picker 
                                        flat
                                        width="300px"
                                        v-else-if="css.select_type === 'color_picker'"
                                        @input="selectPluginOption(block_key, css.param_type, css_name, $event, css, css_block, 'color', null)"
                                        :value="parseColor(plugin_param[block_key][css.param_type][css_name], css_name)"
                                    >
                                    </v-color-picker>
                                </v-menu>
                                <v-btn
                                    v-else
                                    icon
                                    disabled
                                    color="#FFF"
                                >
                                    <v-icon>mdi-menu-down</v-icon>
                                </v-btn>
                            </div>
                        </template>
                    </div>

                </template>
            </div>
        </template>

        <!-- HTML 編輯器 -->
        <v-dialog
            v-model="html_code_setting.is_open"
            width="850"
        >

            <v-card
            >
                <v-card-title class="text-h6 lighten-2">
                    <i 
                        class="material-icons mr-3"
                    >
                        web
                    </i>
                    編輯HTML
                </v-card-title>

                <v-card-text
                    class="pl-6 pr-6"

                >
                    <div
                        style="border: solid 1px rgba(0,0,0,.12);"
                    >
                        <codemirror 
                            :key="html_code_setting.code_key"
                            v-show="html_code_setting.is_code_block_show"
                            ref="code-editor"
                            v-model="html_code_setting.value" 
                            :options="html_code_setting.options"
                            @ready="refreshCodeEditor"
                        >
                        </codemirror>
                    </div>
                </v-card-text>

                <v-card-text
                    class="pl-6 pr-6"

                > 
                    <div
                        style="max-width: 15em;"
                    >
                        <v-select
                            return-object
                            v-model="html_code_setting.selected_item"
                            outlined
                            dense
                            :items="html_code_setting.items"
                            hide-details
                        >
                        </v-select>
                    </div>
                    <p
                        class="pb-0 mt-1"
                    >
                        {{html_code_setting.selected_item.description}}
                        <span v-if="html_code_setting.selected_item.highlight"
                            style="color:red;"
                        >
                            {{html_code_setting.selected_item.highlight}}
                        </span>
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey"
                        text
                        @click="cancelEditHTML"
                    >
                        取消
                    </v-btn>
                    <v-btn
                        color="primary"
                        text
                        @click="confirmEditHTML"
                    >
                        確定
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- 插件編輯器 -->
        <v-dialog
            v-if="plugin_setting.is_open"
            v-model="plugin_setting.is_open"
            width="800"
        >

            <v-card
            >
                <v-card-title class="text-h6 lighten-2">
                    <i 
                        class="material-icons mr-3"
                    >
                        extension
                    </i>
                    加入插件
                </v-card-title>

                <v-card-text
                    class="pl-6 pr-6"
                    v-if="plugin_setting.selected_plugin"
                >
                    <div class="text-subtitle-2 mb-2">
                        示意圖:
                    </div>
                    <div v-html="plugin_setting.selected_plugin.template_html"></div>
                    <p
                        class="pb-0 mt-1"
                    >
                        {{plugin_setting.selected_plugin.description}}
                        <span v-if="plugin_setting.selected_plugin.highlight"
                            style="color:red;"
                        >
                            {{plugin_setting.selected_plugin.highlight}}
                        </span>
                    </p>
                </v-card-text>

                <v-card-text
                    class="pl-6 pr-6"

                >
                    <div class="text-subtitle-2 mb-2">
                        類型:
                    </div>

                    <div
                        style="max-width: 15em;"
                    >
                        <v-select
                            return-object
                            v-model="plugin_setting.selected_plugin"
                            outlined
                            dense
                            :items="plugin_setting.plugins"
                            hide-details
                            @change="changePlugin"
                        >
                        </v-select>
                    </div>
                </v-card-text>

                <v-card-text
                    class="pl-6 pr-6"
                    v-if="plugin_setting.selected_plugin.is_activate_position"
                > 
                    <div class="text-subtitle-2 mb-2">
                        插入位置:
                    </div>
                    <div
                        style="max-width: 15em;"
                    >
                        <v-select
                            return-object
                            v-model="plugin_setting.selected_item"
                            outlined
                            dense
                            :items="plugin_setting.items"
                            hide-details
                        >
                        </v-select>
                    </div>
                    <p
                        class="pb-0 mt-1"
                    >
                        {{plugin_setting.selected_item.description}}
                        <span v-if="plugin_setting.selected_item.highlight"
                            style="color:red;"
                        >
                            {{plugin_setting.selected_item.highlight}}
                        </span>
                    </p>
                </v-card-text>

                <v-card-text
                    v-if="plugin_setting.selected_plugin.sub_fields && plugin_setting.selected_plugin.sub_fields.length !== 0"
                    class="pl-6 pr-6"
                >

                    <v-form ref="form" lazy-validation >
                        <v-row v-for="(sub_field, idx) in plugin_setting.selected_plugin.sub_fields" :key="idx">
                            <v-col
                                cols="12"
                                lg="12"
                                md="12"
                                xs="12"
                            >
                                <div class="text-subtitle-2 mb-2">
                                    {{sub_field.name}}
                                </div>
                                <div>
                                    <v-text-field
                                        outlined
                                        type="text"
                                        dense
                                        v-model="sub_field.value"
                                        :rules="[$utils.field_rules.required]"
                                        :placeholder="sub_field.hint"
                                        validate-on-blur
                                    >
                                    </v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-text
                    v-if="plugin_setting.dialog_message"
                    class="pl-6 pr-6 red--text"
                >
                    {{plugin_setting.dialog_message}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey"
                        text
                        @click="cancelPlugin"
                    >
                        取消
                    </v-btn>
                    <v-btn
                        color="primary"
                        text
                        @click="confirmPlugin"
                    >
                        確定
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import online_user_fields from '@/static/online_user_fields.json'
import sales_counter_fields from '@/static/sales_counter_fields.json'
import ba_slider_fields from '@/static/ba_slider_fields.json'
import { mapGetters } from 'vuex'
import { eventBus } from '@/event_bus.js';
import chroma from "chroma-js";

import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/htmlmixed/htmlmixed.js"; 
import 'codemirror/mode/javascript/javascript.js'


export default {
  name: 'Editor',
  props: {
    init_step_historys: Array,
    init_step_history_index: Number,
    vid: String,
  },
  components: {
    codemirror,
  },
  data() {
    return {
      editor_type: '',
      plugin_type: '',
      plugin_static_field: {
        online_user: online_user_fields,
        sales_counter: sales_counter_fields,
        ba_slider: ba_slider_fields
      },
      plugin_fields: {
        online_user: online_user_fields.fields,
        sales_counter: sales_counter_fields.fields,
        ba_slider: ba_slider_fields.fields
      },
      plugin_param: null,
      plugin_action_items: [
        { 
            title: '移除',
            action: 'display',
            inactivate_edit_tags : []
        },
      ],
      items: [
        { 
            title: '移除',
            action: 'display',
            inactivate_edit_tags :[]
        },
        { 
            title: '編輯文字',
            action: 'edit_text',
            inactivate_edit_tags :['IMG', 'IFRAME']
        },
        { 
            title: '編輯HTML',
            action: 'edit_html',
            inactivate_edit_tags :[],
        },
        // {
        //     title: "加入插件",
        //     action: 'edit_plugin',
        //     inactivate_edit_tags :[],
        // }
        // { 
        //     title: '插入HTML',
        //     action: 'insert_html'
        // },
      ],
      hide_css_fields: ['block_title', 'visible', 'target_selector'],

      // 被用text-field input的 css樣式 
      selected_event: null,

      // 被用list-item 選擇的 css樣式
      selected_option: '',

      original_info: '',
      selected_element_selector: '', 
      selected_element_info: '',
      is_edit_text: false,

      menu_open_mapper: {},

      is_drag: false,
      offsetX: 0,
      offsetY: 0,
      tmp_left: 0,
      tmp_top: 0,

      step_historys: [],
      step_history_index: -1,

      html_code_setting: {
        code_key: 0,
        is_open: false,
        is_code_block_show: false,
        options: {
            lint: true,
            line: true,
            theme: "default", // 主题
            tabSize: 4, // 制表符的宽度
            indentUnit: 0, // 一个块应该缩进多少个空格（无论这在编辑语言中意味着什么）。默认值为 2。
            firstLineNumber: 1, // 从哪个数字开始计算行数。默认值为 1。
            readOnly: false, // 只读
            lineWrapping: true, // 自动换行
            autorefresh: true,
            smartIndent: true, // 上下文缩进
            lineNumbers: true, // 是否显示行号
            styleActiveLine: true, // 高亮选中行
            viewportMargin: Infinity, //处理高度自适应时搭配使用
            showCursorWhenSelecting: true, // 当选择处于活动状态时是否应绘制游标
            mode: "htmlmixed",

        },
        value: '',
        copy: '',
        selected_item: {
            "text": "Replace",
            "value": "replace",
            "description": "將整段HTML取代選取元素",
            "highlight": "若使用在按鈕，可能會造成按鈕失效",
        },
        items: [
            {
                "text": "Replace",
                "value": "replace",
                "description": "將整段HTML取代選取元素",
                "highlight": "若使用在按鈕，可能會造成按鈕失效",
            },
            {
                "text": "Insert",
                "value": "afterbegin",
                "description": "將整段HTML插入至選取元素內的最上方",
                "highlight": ""
            },
            {
                "text": "Append",
                "value": "beforeend",
                "description": "將整段HTML插入至選取元素內的最下方",
                "highlight": ""
            },
            {
                "text": "Before",
                "value": "beforebegin",
                "description": "將整段HTML插入至選取元素外的上方",
                "highlight": ""
            },
            {
                "text": "After",
                "value": "afterend",
                "description": "將整段HTML插入至選取元素外的下方",
                "highlight": ""
            },
        ]
      },
      plugin_setting: {
        is_open: false,
        dialog_message: '',
        selected_plugin: null,
        plugin_tmp_param: null,
        plugins: [
            {
                "text": "在線人數",
                "value": "online_user",
                "description": "顧客進入頁面，會在最小 ～ 最大之間，隨機生成一個亂數顯示",
                "highlight": "",
                "template_html":`
                <div opt99-plugin="online_user" opt99-vid="{{vid}}" opt99-id="{{tmp-id}}" style="display:flex; text-align:left;margin-top:0px; margin-bottom:0px;">
                    <div name="container" 
                        opt99-is_interval_count="0" opt99-top="100" opt99-bot="50" opt99-value="60" opt99-id="{{tmp-id}}"
                        style="line-height: 1.2;max-width:100%;display:inline-flex;background-color:#FF6699; border-radius:5px;align-items:center;padding:0px 10px 0px 10px;"
                    >
                        <div name="icon" style="color:#000000; font-size:30px;display:flex;margin:0px 0px 0px 0px; padding: 3px 0px;">👀</div>
                        <div style="display:flex;align-items:center;"><span name="start_description" style="font-size:20px; color:#FFFFFF; padding-left:10px;">目前有</span><span name="counter" style="font-size:20px; color:#FFFFFF; padding:0px 5px;">100</span><span name="end_description" style="font-size:20px; color:#FFFFFF;">人正在觀看</span></div>
                    </div>
                </div>
                `,
                activate_tags: [],
                init_setting: {
                    "id": "",
                    "bot": 50,
                    "top": 100,
                    "add_col": '',
                },
                is_activate_position: true,
                sub_fields: []
            },
            {
                "text": "銷售計數器",
                "value": "sales_counter",
                "description": "顧客進入頁面，顯示銷售的數量，根據選擇的模式在顧客進行購買後進行增減計算",
                "highlight": "",
                is_activate_position: true,
                activate_tags: [],
                "template_html":`
                <div opt99-plugin="sales_counter" opt99-vid="{{vid}}" opt99-id="{{tmp-id}}" style="display:flex;">
                    <div name="container" opt99-id="{{tmp-id}}" cal_type="-" multiple="1" init="80" loop="false" repeat_from="60" top="1000" style="line-height: 1.2; max-width: 100%; display: inline-flex; border-radius: 5px; align-items: center; padding: 5px;">
                        <div style="display:flex;align-items:center;">
                            <span name="start_description" style="font-size: 14px; color: rgb(229, 18, 18);">只剩</span>
                            <span name="counter" style="font-size: 35px; color: rgb(221, 21, 21); padding: 0px 5px;">100</span>
                            <span name="end_description" style="font-size: 14px; color: rgb(223, 19, 19);">組！即將完售</span>
                        </div>
                    </div>
                </div>
                `,
                init_setting: {
                    id: "",
                    cal_type: "-",
                    multiple: "1",
                    init: 80,
                    loop: true,
                    repeat_from: 50,
                    top: 100,
                    add_col: '',
                },
                sub_fields: []
            },
            {
                text: "BA 拉門",
                value: "ba_slider",
                description: "把圖片轉為拖拉的對照圖",
                highlight: "",
                template_html: `
                    <div 
                        opt99-plugin="ba_slider" 
                        opt99-vid="{{vid}}" 
                        opt99-id="{{tmp-id}}"
                        style="display: flex;justify-content: center;"
                    >
                        <div
                            name="container"
                            opt99-id="{{tmp-id}}"
                            start_percent="50"
                            direction="horizontal"
                            style="
                                overflow: hidden;
                                position: relative;
                                display: inline-block;
                            "
                        >

                            <div name="slider-new"
                                style="
                                    position: absolute;
                                    z-index: 3;
                                    inset: 0px;
                                    overflow: hidden;
                                    width: 50%;
                                "
                            >
                                <img 
                                    src="{{new_img_url}}"
                                >
                            </div>
                            <input 
                                type="range" 
                                value="50" 
                                min="0" 
                                max="100" 
                                style="
                                    position: absolute;
                                    z-index: 4;
                                    top: 0px;
                                    bottom: 0px;
                                    left:0px;
                                    right:0px;
                                    opacity: 0;
                                    cursor: pointer;
                                "
                            >
                            <div 
                                name="opt99-slider-btn"
                                style="
                                    left: 38%;
                                    position: absolute;
                                    z-index: 2;
                                    pointer-events: none;
                                    opacity: 1;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate3d(-50%, -50%, 0);
                                    color: #000;
                                    background: rgba(255, 255, 255, 0.5);
                                    width: 48px;
                                    height: 48px;
                                    border-radius: 50%;
                                    box-shadow: 0 0 6px rgba(0, 0, 0, 0);
                                    transition: background 0.3s, box-shadow 0.3s, opacity 0.5s 0.25s;
                                    z-index: 5;
                                "
                            >
                                <div 
                                    name="opt99-slider-btn-left"
                                    style="
                                        right: 0;
                                        transform: rotate(135deg);
                                        position: absolute;
                                        width: 10px;
                                        height: 10px;
                                        top: 50%;
                                        border-top: solid 2px;
                                        border-left: solid 2px;
                                        transform-origin: 0 0;
                                    "
                                    ></div>
                                <div
                                    name="opt99-slider-btn-right" 
                                    style="
                                        left: 10px;
                                        transform: rotate(-45deg);
                                        position: absolute;
                                        osition: absolute;
                                        width: 10px;
                                        height: 10px;
                                        top: 50%;
                                        border-top: solid 2px;
                                        border-left: solid 2px;
                                        transform-origin: 0 0;
                                    "
                                ></div>
                            </div>
                        </div>
                    </div>
                `,
                is_activate_position: false,
                activate_tags: ['IMG'],
                init_setting: {
                    id: "",
                    new_img_url: "",
                    start_percent: "50",
                    direction: 'horizontal',
                },
                sub_fields: [
                    {
                        id: 'new_img_url',
                        name: '覆蓋圖片的網址',
                        type: "text",
                        value: "",
                        hint: '',
                        message: '',
                    }
                ]
            }
        ],
        value: '',
        copy: '',
        selected_item: {
            "text": "Before",
            "value": "beforebegin",
            "description": "插入至選取元素外的上方",
            "highlight": ""
        },
        items: [
            // {
            //     "text": "Insert",
            //     "value": "afterbegin",
            //     "description": "插入至選取元素內的最上方",
            //     "highlight": ""
            // },
            // {
            //     "text": "Append",
            //     "value": "beforeend",
            //     "description": "插入至選取元素內的最下方",
            //     "highlight": ""
            // },
            {
                "text": "Before",
                "value": "beforebegin",
                "description": "插入至選取元素外的上方",
                "highlight": ""
            },
            {
                "text": "After",
                "value": "afterend",
                "description": "插入至選取元素外的下方",
                "highlight": ""
            },
        ]
      },
      plugin_setting_copy: null,
      is_interactivate_plugin: false,

    };
  },
  created: function(){
    eventBus.$on('update-editor-ele', this.updateEditorEle);
    eventBus.$on('confirm-edit-callback', this.confirmEditCallback)
    eventBus.$on('update-editor-history', this.updateHistory);
    this.step_historys = this.init_step_historys
    this.step_history_index = this.init_step_history_index
    console.log('step_historys', this.step_historys)
    console.log('step_history_index', this.step_history_index)
    console.log('CCC',codemirror)
  },
  destroyed: function(){
    eventBus.$off('update-editor-ele', this.updateEditorEle);
    eventBus.$off('confirm-edit-callback', this.confirmEditCallback)
    eventBus.$off('update-editor-history', this.updateHistory);
  },   
  mounted: function(){
    console.log('Editor')
    let dragElement = this.$refs['editor']
    let that = this

    // 要可以移動
    document.addEventListener('mousemove', function(e) {
      if (that.is_drag) {
        dragElement.style.left = (e.clientX - that.offsetX) + 'px'
        dragElement.style.top = (e.clientY - that.offsetY) + 'px'
      }
    });

    document.addEventListener('mouseup', function() {
      that.is_drag = false;
    //   that.$store.commit('setIsOpenOverlay', false)
    });
  },
  methods: {
    refreshCodeEditor: function(){
        let that = this
        setTimeout(function(){
            that.$refs['code-editor'].refresh()
            that.html_code_setting.is_code_block_show = true
        }, 300)
    },
    changeAttribute: function(selected_element_info, change_attribute, event){
        console.log('selected_element_info', selected_element_info)
        console.log('change_attribute', change_attribute)
        console.log('new_val', event)

        if (!this.selected_element_selector) {
            return
        }
        if (selected_element_info.attributes[change_attribute] === event.target.value) {
            console.log('沒變不改')
            return
        }

        // 更新元素
        let data = {
            nodeName: selected_element_info.nodeName,
            type: "attribute",
            selector: this.selected_element_selector,
            attribute: change_attribute,
            original_info: JSON.parse(JSON.stringify(selected_element_info)),
            value: selected_element_info.attributes[change_attribute],
            new_value: event.target.value
        }
        eventBus.$emit('update-selected-element', data, 'next');
        
        this.recordHistory(data)
    },
    changeStyle: function(selected_element_info, css_name, event, selected_item, is_record, plugin_data){
        console.log('selectorrrr', this.selected_element_selector)
        console.log('selected_element_info', selected_element_info)
        console.log('change_style', css_name)
        console.log('new_val', event)
        console.log('selected_item', selected_item)
        console.log('original', this.original_info)

        if (!this.selected_element_selector || !this.selected_element_info) {
            return
        }

        if (!event && !selected_item) {
            return
        }

        let new_val = ''
        // color的情形
        if (css_name.includes('color')) {
            // 從color picker 來的
            if (selected_item) {
                try {
                    console.log('change_color',event)

                    let rgba_color = [
                        event.r,
                        event.g,
                        event.b,
                        event.a,
                    ]
                    let color = chroma(rgba_color)
                    let css_color_string = color.css();
                    new_val = css_color_string
                } catch (error) {
                    console.log('change_color_parse_error', error)
                }
            }
            else {
                new_val = event.target.value
            }
        }
        else if (selected_item) {
            new_val = selected_item.value
        }
        else {
            new_val = event.target.value
        }
            

        // 如果一樣的話，不變
        if (this.original_info.css[css_name] === new_val) {
            console.log('沒變不改')
            return
        }

        const original_info = JSON.parse(JSON.stringify(this.original_info))
        if (!plugin_data) {
            plugin_data = ''
        }
        // 更新元素
        let data = {
            type: "css",
            selector: this.selected_element_selector,
            css: css_name,
            original_info: original_info,
            value: original_info.css[css_name],
            new_value: new_val,
            plugin_data: plugin_data
        }
        
        eventBus.$emit('update-selected-element', data, 'next');

        if (!is_record) {
            return
        }
        // 歷史紀錄
        this.recordHistory(data)
    },
    selectedEditMethod: function(action){
        // this.$store.commit('setIsOpenOverlay', false)
        switch (action) {
            case 'display':
                this.changeStyle(
                    this.selected_element_info,
                    'display',
                    'none',
                    {value: 'none'},
                    true
                )
                break
            case 'edit_text':
                eventBus.$emit('edit-text', true, {
                    selector: this.selected_element_selector,
                    selected_element_info: this.selected_element_info
                });
                this.is_edit_text = true
                // this.$store.commit('setIsEditText', true)
                this.tmp_left = getComputedStyle(this.$refs['editor']).left
                this.tmp_top = getComputedStyle(this.$refs['editor']).top
                this.$refs['editor'].style.left = ''
                this.$refs['editor'].style.top = ''
                break
            case 'edit_html':
                console.log('this.selected_element_info.outerHtml',this.selected_element_info.outerHtml)
                this.html_code_setting.is_open = true
                this.html_code_setting.value = this.selected_element_info.outerHtml
                this.html_code_setting.copy = this.selected_element_info.outerHtml
                this.refreshCodeEditor()
                break;
            case 'edit_plugin':
                this.plugin_setting_copy = JSON.parse(JSON.stringify(this.plugin_setting))
                this.plugin_setting.is_open = true
                this.plugin_setting.selected_item = this.plugin_setting.items[0]
                this.plugin_setting.selected_plugin = this.plugin_setting.plugins[0]
                this.plugin_setting.value = this.selected_element_info.outerHtml
                this.plugin_setting.copy = this.selected_element_info.outerHtml
                break;
        }
    },
    selectedPluginEditMethod(action){
        console.log('action:', action)
        console.log('plugin_param', this.plugin_param)
        // 讀要給後端的值
        let expected_setting = {}
        let basic_attribute = this.plugin_param['basic_setting']['attribute']
        let key_mapper = this.plugin_static_field[this.plugin_type]['key_mapper']
        let key_type_mapper = this.plugin_static_field[this.plugin_type]['key_type_mapper']
        this.plugin_static_field[this.plugin_type].expected_keys.forEach(function(expected_key){
            let map_key = key_mapper[expected_key]
            expected_setting[expected_key] = basic_attribute[map_key]
            if (key_type_mapper[expected_key]) {
                if (key_type_mapper[expected_key] === 'int') {
                    expected_setting[expected_key] = parseInt(expected_setting[expected_key])
                }
            }
        })
        let plugin_data = {
            method: 'delete',
            type: this.plugin_type,
            id: expected_setting['id'],
            selector: this.selected_element_selector,
            setting: expected_setting
        }    
        this.deletePlugin(plugin_data)
    },
    changeHTML: function(method, old_val, new_val, is_record, plugin_data){
        console.log('change_html_la: ' + method, new_val)
        const original_info = JSON.parse(JSON.stringify(this.original_info))
        if (!plugin_data) {
            plugin_data = ''
        } 
        let data = {
            type: "html",
            selector: this.selected_element_selector,
            original_info: original_info,
            value: old_val,
            new_value: new_val,
            method: method,
            plugin_data: plugin_data,
        }

        eventBus.$emit('update-selected-element', data, 'next');

        if (!is_record) {
            return
        }

        this.recordHistory(data)
    },
    recordHistory: function(data){
        // console.log('紀錄紀錄紀錄紀錄紀錄紀錄紀錄紀錄')
        let step_historys = this.step_historys
        let idx = this.step_history_index
        // console.log('idx',idx + 1)
        // console.log('step_historys.length - idx - 1', step_historys.length - idx - 1)
        step_historys.splice(idx + 1, step_historys.length - idx - 1)
        // console.log('step_historys_1',step_historys)

        step_historys.push(data)
        idx = step_historys.length - 1
        // console.log('step_historys_2', step_historys)
        // console.log('idx_2', idx)
        // this.$store.commit('setStepHistorys', step_historys)
        // this.$store.commit('setHistoryIndex', idx)
        eventBus.$emit('update-header-history', step_historys, idx);
        this.step_historys = step_historys 
        this.step_history_index = idx

        if (data.plugin_data) {
            eventBus.$emit('update-header-plugin-history', data.plugin_data, 'next');
        }
        // this.step_history_index = idx
        // this.step_historys = step_historys
    },
    handleHistory: function(step_type){
        let idx = this.step_history_index

        if (step_type === 'next') {
            console.log('下一步')
            idx += 1
        }
        else {
            console.log('上一步')
        }
        console.log('idx', idx)
        const ele = this.step_historys[idx]

        eventBus.$emit('update-selected-element', ele, step_type, true);
        
        if (step_type !== 'next') {
            this.step_history_index = idx - 1
            eventBus.$emit('update-header-history', this.step_historys, this.step_history_index);
        }
        else {
            this.step_history_index = idx
            eventBus.$emit('update-header-history', this.step_historys, this.step_history_index); 
        }

        if (ele.plugin_data) {
            eventBus.$emit('update-header-plugin-history', ele.plugin_data, step_type);
        }

        // console.log('after_commit',this.step_history_index)
        
    
    },
    closeEditor: function(){
        this.$store.commit('optimize/SET_IS_OPEN_EDITOR', false)
    },
    parseColor: function(color){
        console.log('css_name_parse_color', color)
        try {
            color = chroma(color)
            console.log('chroma_color',color)
            const rgba = color.rgba(); // 獲取 RGBA 格式的顏色值
            console.log(rgba);
            color = {
                r: rgba[0],
                g: rgba[1],
                b: rgba[2],
                a: rgba[3],
            }
        } catch (error) {
            console.log('parse_error', error)
            color = {
                r: 0,
                g: 0,
                b: 0,
                a: 0,
            }
        }
        console.log('parse_color_result', color)
        return color
    },
    selectOption: function(event, item, css_name){
        this.selected_event = event
        this.selected_option = item
        console.log(this.selected_event)
        console.log(this.selected_option)

        if (css_name) {
            this.changeStyle(
                this.selected_element_info,
                css_name,
                this.selected_option,
                this.selected_option,
                false
            )
        }
    },
    handleMenu: function(css_name, is_open){
        console.log(css_name, is_open)
        if (is_open === true) {
            this.menu_open_mapper[css_name] = true 
            // this.original_info = JSON.parse(JSON.stringify(this.selected_element_info))
            // this.$store.commit('setIsOpenOverlay', true)
            return
        }
        else {
            this.menu_open_mapper[css_name] = false 
            // this.$store.commit('setIsOpenOverlay', false)
        }
        console.log('-----menu改樣式-----')
        this.changeStyle(
            this.selected_element_info,
            css_name,
            this.selected_option,
            this.selected_option,
            true
        )
        // if (css_name.includes('color')) {
        //     this.changeStyle(
        //         this.selected_element_info,
        //         css_name,
        //         this.selected_option,
        //         this.selected_option,
        //         true
        //     )
        // }
        // else {
        //     this.changeStyle(
        //         this.selected_element_info,
        //         css_name,
        //         this.selected_option,
        //         this.selected_option,
        //         true
        //     )
        // }

    },
    handleOverlay: function(is_open){
        if(is_open) {
            // this.$store.commit('setIsOpenOverlay', true)
        }
        else {
            // this.$store.commit('setIsOpenOverlay', false)
        }
    },
    cancelEdit: function(){
        const original_info = JSON.parse(JSON.stringify(this.original_info))
        if (!this.is_interactivate_plugin) {
            this.changeHTML('replaceText', original_info.innerHtml, original_info.innerHtml, false)
        }
        else {
            this.is_interactivate_plugin = false
        }
        eventBus.$emit('edit-text', false);
        this.$refs['editor'].style.left = this.tmp_left
        this.$refs['editor'].style.top = this.tmp_top
        this.is_edit_text = false
    },
    confirmEdit: function(){
        // const original_info = JSON.parse(JSON.stringify(this.original_info))
        eventBus.$emit('get-selected-element-info', {
            "selector": this.selected_element_selector,
            'method': 'replaceText'
        });

        // eventBus.$emit('update-selected-element-info', this.selected_element_selector);
        

        // if (original_info.outerHtml !== this.selected_element_info.outerHtml) {
        //     this.changeHTML('replaceText', original_info.outerHtml, this.selected_element_info.outerHtml, true)
        // }
        // this.$refs['editor'].style.left = this.tmp_left
        // this.$refs['editor'].style.top = this.tmp_top
        // // eventBus.$emit('edit-text', false);    
        // this.is_edit_text = false   
    },
    confirmEditCallback: function(data){
        console.log('confirmEditCallback', data)

        switch (data.method){
            case 'replaceText':

                if (this.original_info.innerHtml !== data.selected_element_info.innerHtml){
                    this.changeHTML(
                        data.method,
                        this.original_info.innerHtml,
                        data.selected_element_info.innerHtml,
                        true
                    )
                    eventBus.$emit('edit-text', false);
                    this.$refs['editor'].style.left = this.tmp_left
                    this.$refs['editor'].style.top = this.tmp_top
                    this.is_edit_text = false
                }

                break;
        }

        // if (this.original_info.innerHtml !== this.selected_element_info.outerHtml) {
        //     this.changeHTML('replaceText', original_info.outerHtml, this.selected_element_info.outerHtml, true)
        // }
    },
    moveEditor: function(e){
        let that = this;
        let dragElement = this.$refs['editor']
        that.is_drag = true
        // that.$store.commit('setIsOpenOverlay', true)
        that.offsetX = e.clientX - dragElement.offsetLeft;
        that.offsetY = e.clientY - dragElement.offsetTop;
    },
    updateEditorEle: function(data){
        console.log('callback_data:', data)
        console.log('menu_open:', this.menu_open_mapper)
        let is_open_menu = false
        let open_menu_keys = Object.keys(this.menu_open_mapper)
        for (let idx = 0; idx < open_menu_keys.length; idx++) {
            if (this.menu_open_mapper[open_menu_keys[idx]]) {
                is_open_menu = true
            }
        }
        console.log('is_open_menu:', is_open_menu)
        if (!is_open_menu) {
            console.log('保留原始')
            this.original_info = JSON.parse(JSON.stringify(data.selected_element_info))
            this.selected_element_selector = data.selected_element_selector
            this.selected_element_info = data.selected_element_info
            this.editor_type = data.editor_type
            this.plugin_type = data.plugin_type
            this.plugin_param = data.plugin_param
            console.log('plugin_type', this.plugin_type)
            // 點到element就開編輯器
            if (this.activate_editor === 'editor') {
                this.$store.commit('optimize/SET_IS_OPEN_EDITOR', true)
            }
            
            // 有需要回寫history再回寫
            if (data.back_history) {
                this.recordHistory(data.back_history)
            }
        } 
        // this.selected_element_selector = data.selected_element_selector
        // if (data.css === undefined || !data.css.includes('color')) {
        //     this.selected_element_info = data.selected_element_info
        // }
    },
    updateHistory: function(historys, history_idx){
        this.step_historys = historys
        this.step_history_index = history_idx
    },
    cancelPlugin: function(){
        console.log()
        this.plugin_setting = JSON.parse(JSON.stringify(this.plugin_setting_copy))
    },
    confirmPlugin: function() {
        console.log('------確認新增------')
        console.log(this.plugin_setting.selected_item)
        console.log(this.plugin_setting.selected_plugin)
        console.log(this.selected_element_info)
        let result = true
        if (this.$refs.form) {
            result = this.$refs.form.validate();
            console.log('validate',result)
        }

        if (!result) {
            return
        }

        if (this.plugin_setting.dialog_message) {
            return
        }

        let method = this.plugin_setting.selected_item.value
        let template_html = this.plugin_setting.selected_plugin.template_html
        let tmp_id = `tmp-${new Date().getTime()}`
        template_html = template_html.replaceAll('{{tmp-id}}', tmp_id)
        template_html = template_html.replace('{{vid}}', this.vid)
        let plugin_data = {
            method: 'create',
            type: this.plugin_setting.selected_plugin.value,
            id: tmp_id,
            selector: this.selected_element_selector,
            setting: this.plugin_setting.selected_plugin.init_setting,
            sub_id: this.vid
        }
        plugin_data.selector = `div[opt99-plugin="${plugin_data.type}"][opt99-vid="${plugin_data.sub_id}"][opt99-id="${plugin_data.id}"]`
        this.plugin_setting.selected_plugin.sub_fields.forEach(function(field){
            template_html = template_html.replaceAll(`{{${field.id}}}`, field.value)
        })

        this.changeHTML(method, this.plugin_setting.copy ,template_html, true, plugin_data)
        this.cancelPlugin()
        this.plugin_setting.is_open = false
    },
    lockInputPluginField(field, is_lock, block_key, param_type, css_name, current_event, css, css_block){
        field.is_edit = is_lock
        if (is_lock) {
            console.log('----------鎖定欄位----------')
        }
        else {
            console.log('----------解鎖欄位----------')
            this.inputPluginField(block_key, param_type, css_name, current_event, css, css_block, true)
        }
    },
    inputPluginField: function(block_key, param_type, css_name, current_event, css, css_block, is_record){
        console.log('嘿嘿', this.plugin_param)
        console.log('block_key:', block_key)
        console.log('param_type:', param_type)
        console.log('css_name:', css_name)
        console.log('current_event:', current_event)
        console.log('is_lock:', css.is_edit)
        console.log('is_record_step:', is_record)
        if (!css.is_edit) {
            console.log('改！')
            let old_value = this.plugin_param[block_key][css.param_type][css_name]
            let new_value = current_event.target ? current_event.target.value : current_event
            let new_setting = JSON.parse(JSON.stringify(this.plugin_param))
            new_setting[block_key][css.param_type][css_name] = new_value

            // 讀要給後端的值
            let old_setting = {}
            let expected_setting = {}
            let old_attribute = this.plugin_param['basic_setting']['attribute']
            let basic_attribute = new_setting['basic_setting']['attribute']
            let key_mapper = this.plugin_static_field[this.plugin_type]['key_mapper']
            let key_type_mapper = this.plugin_static_field[this.plugin_type]['key_type_mapper']
            this.plugin_static_field[this.plugin_type].expected_keys.forEach(function(expected_key){
                let map_key = key_mapper[expected_key]
                old_setting[expected_key] = old_attribute[map_key]
                expected_setting[expected_key] = basic_attribute[map_key]
                if (key_type_mapper[expected_key]) {
                    if (key_type_mapper[expected_key] === 'int') {
                        old_setting[expected_key] = parseInt(old_setting[expected_key])
                        expected_setting[expected_key] = parseInt(expected_setting[expected_key])
                    }
                    else if (key_type_mapper[expected_key] === 'bool') {
                        if (old_setting[expected_key] === 'true') {
                            old_setting[expected_key] = true
                        }
                        else {
                            old_setting[expected_key] = false
                        }
                        if (expected_setting[expected_key] === 'true') {
                            expected_setting[expected_key] = true
                        }
                        else {
                            expected_setting[expected_key] = false
                        }
                    }
                }
            })
            let plugin_data = {
                method: 'update',
                type: this.plugin_type,
                id: expected_setting['id'],
                selector: this.selected_element_selector,
                old_setting: old_setting,
                setting: expected_setting
            }

            let data = {
                type: "plugin",
                selector: this.selected_element_selector,
                target_selector: css_block.target_selector,
                param_type: css.param_type,
                param_name: css_name,
                value: old_value,
                new_value: new_value,
                plugin_data: plugin_data
            }
            console.log('data', data)
            eventBus.$emit('update-selected-element', data, 'next');
            if (is_record) {
                console.log('紀錄', data)
                this.recordHistory(data)
            }
            else {
                console.log('不紀錄', data)
            }
        }
    },
    handlePluginMenu(css_name, is_open){
        console.log(css_name, is_open)
        if (is_open === true) {
            this.menu_open_mapper[css_name] = true 
            // this.original_info = JSON.parse(JSON.stringify(this.selected_element_info))
            // this.$store.commit('setIsOpenOverlay', true)
            return
        }
        else {
            this.menu_open_mapper[css_name] = false 
            // this.$store.commit('setIsOpenOverlay', false)
        }
        console.log('-----menu改樣式-----')
        if (!this.plugin_setting.plugin_tmp_param) {
            return
        }
        this.inputPluginField(
            this.plugin_setting.plugin_tmp_param.block_key,
            this.plugin_setting.plugin_tmp_param.param_type,
            this.plugin_setting.plugin_tmp_param.css_name,
            this.plugin_setting.plugin_tmp_param.new_val,
            this.plugin_setting.plugin_tmp_param.css,
            this.plugin_setting.plugin_tmp_param.css_block,
            true
        )
    },
    selectPluginOption(block_key, param_type, css_name, current_event, css, css_block, selected_type, selected_item){
        console.log('嘿嘿Option', this.plugin_param)
        console.log('block_key:', block_key)
        console.log('param_type:', param_type)
        console.log('css_name:', css_name)
        console.log('current_event:', current_event)
        console.log('css_block:', css_block)
        console.log('css:', css)
        console.log('selected_type:', selected_type)
        console.log('selected_item:', selected_item)
        let new_val = ''
        if (selected_type === 'item') {
            new_val = selected_item.value
        }
        else {
            try {
                let rgba_color = [
                    current_event.r,
                    current_event.g,
                    current_event.b,
                    current_event.a,
                ]
                let color = chroma(rgba_color)
                new_val = color.css();
            } catch (error) {
                new_val = 'rgba(255,0,0,1)'
            }
        }

        let tmp_param = {
            block_key: block_key,
            param_type: param_type,
            css_name: css_name,
            new_val: new_val,
            css: css,
            css_block: css_block,
        }
        this.plugin_setting.plugin_tmp_param = tmp_param
        if (selected_type !== 'item') {
            this.inputPluginField(
                this.plugin_setting.plugin_tmp_param.block_key,
                this.plugin_setting.plugin_tmp_param.param_type,
                this.plugin_setting.plugin_tmp_param.css_name,
                this.plugin_setting.plugin_tmp_param.new_val,
                this.plugin_setting.plugin_tmp_param.css,
                this.plugin_setting.plugin_tmp_param.css_block,
                false
            )
        }

    },
    cancelEditHTML: function(){
        this.html_code_setting.copy = ''
        this.html_code_setting.value = ''
        this.html_code_setting.is_code_block_show = false
        this.html_code_setting.is_open = false
        this.html_code_setting.code_key += 1
    },
    confirmEditHTML: function(){
        console.log('確認修改html',this.html_code_setting.selected_item)
        let method = this.html_code_setting.selected_item.value
        this.changeHTML(method, this.html_code_setting.copy ,this.html_code_setting.value, true)
        this.cancelEditHTML()
    },
    getDisaplyValue(field_id, field_display_map, plugin_param, param){
        console.log('getDisaplyValue_field_id:', field_id)
        console.log('getDisaplyValue_field_id:', field_display_map)
        console.log('getDisaplyValue_field_id:', plugin_param)
        console.log('getDisaplyValue_field_id:', param)

        let return_value = param[field_id]

        if (field_display_map && field_display_map[field_id]) {
            let current_map = field_display_map[field_id]
            let related_field = plugin_param[current_map.block_key][current_map.param_type][current_map.param_key]
            console.log('related_field:', related_field)
            let display_value = current_map['value'][related_field]
            return_value = display_value
        }

        return return_value

    },
    getShowValue(value_mapper, value) {
        let show = value
        if (value_mapper) {
            show = value_mapper[value]
        }
        return show
    },
    deletePlugin(payload){
        // 更新元素
        let data = {
            type: "delete_plugin",
            selector: payload.selector,
            plugin_data: payload
        }
        console.log('delete_plugin', data)

        eventBus.$emit('update-selected-element', data, 'next');
    },
    changePlugin(){
        console.log('change',this.selected_element_info)
        console.log('selected_plugin', this.plugin_setting.selected_plugin)
        let that = this
        if (this.plugin_setting.selected_plugin.value === 'ba_slider') {
            this.plugin_setting.selected_plugin.sub_fields.forEach(function(sub_field){
                if (sub_field.id === 'new_img_url') {
                    let width = parseInt(that.selected_element_info.css.width.replace('px',''))
                    let height = parseInt(that.selected_element_info.css.height.replace('px',''))
                    sub_field.hint = `至少要提供 ${width} x ${height} 大小的圖片，才能覆蓋圖片`
                }
            })

            if (this.selected_element_info.nodeName !== 'IMG') {
                this.plugin_setting.dialog_message = '選擇的元素必須是圖片，才能使用此功能。'
            }
        }
    },
    async interActive(){
        await eventBus.$emit('edit-text', true, {
            selector: this.selected_element_selector,
            selected_element_info: this.selected_element_info
        });
        this.is_edit_text = true
        this.is_interactivate_plugin = true
        // this.$store.commit('setIsEditText', true)
        this.tmp_left = getComputedStyle(this.$refs['editor']).left
        this.tmp_top = getComputedStyle(this.$refs['editor']).top
        this.$refs['editor'].style.left = ''
        this.$refs['editor'].style.top = ''
    }
  },
  computed: {
    ...mapGetters([
        // 'selected_element_selector', 
        // 'selected_element_info',
        // 'step_historys', 
        // 'step_history_index',
        'css_mapper', 
        'attribute_mapper',
        // 'ele_changed_history',
        // 'is_open_overlay',
        // 'is_edit_text'
    ]),
    ...mapGetters('optimize', [
        'activate_editor',
        'is_open_editor'
    ]),
  }
}
</script>

<style scoped>
.theme--light.v-btn.v-btn--disabled, .theme--light.v-btn.v-btn--disabled .v-icon  {
    color: rgba(255,255,255,.26)!important;
}
.v-application p {
    margin-bottom: 0px;
}
.optimize99-ab-test-editor {
    background-color: white;
    bottom: 15px;
    border-radius: 2px;
    height: 500px;
    position: fixed;
    right: 15px;
    width: 280px;
    z-index: 3;
    box-shadow: 0 6px 6px -3px rgb(0 0 0 / 20%), 0 10px 14px 1px rgb(0 0 0 / 14%), 0 4px 18px 3px rgb(0 0 0 / 12%);
}
.optimize99-ab-test-editor.optimize99-ab-test-editor-edit-mode {
    height: fit-content;
    width: auto;
    padding: 10px;
}
.optimize99-ab-test-editor-header {
    border-radius: 2px 2px 0 0;
    padding: 0 0.5em;
    min-height: 50px;
    position: relative;
    background-color: rgb(26,115,232);
    color: rgb(255,255,255);
}
.optimize99-ab-test-editor-header.plugin {
    background-color: #9c27b0 !important
}
.optimize99-ab-test-editor-header-icon {
    font-size: 20px !important;
    cursor: pointer;
}
.optimize99-ab-test-editor-tool{
    padding: 0 16px 16px;
    overflow-y: scroll;
    height: 450px;
}
.optimize99-ab-test-editor-field-title {
    color: rgba(0,0,0,.4);
    font-size: 13px;
    font-weight: 500;
    margin:13px 0px 6px 0px !important;
    padding: 0px;
}
.optimize99-ab-test-editor-field {
    display: flex;
    flex-direction: row;
    align-items: center;
    max-width: 100%;
    padding:2px 0px;
    position: relative;
}
.optimize99-ab-test-editor-field > i, .optimize99-ab-test-editor-field > span {
    color: rgba(0,0,0,0.54);
    margin-right: 0.5em;
    
}
.optimize99-ab-test-editor-field-input {
    width: 9em;
    max-width: 100%;
    line-height: 1em;
}
/* ::v-deep .v-text-field input  {
    color: rgba(0,0,0,0.3) !important;
} */
.item-selected {
    background: rgba(0,0,0,0.08);
}
.v-menu {
    display: block;
}
.v-color-picker__edit {
    flex-direction: column;
}
</style>
